import React, { useState } from "react";
import ModaleV2 from "./ModaleV2";
import { collectDossiers } from "../services/bibliotheque";

// ===================================================================
// The Crowd v2 — Bibliotheques : modales
//
// Formulaires seuls : l'appel API est fait par la page, via `onValider`
// (qui renvoie une promesse). Une erreur levee par `onValider` est
// affichee dans la modale, qui reste ouverte.
// ===================================================================

function optionsDossiers(tree) {
  return tree ? collectDossiers(tree) : [{ label: "(Racine)", value: "" }];
}

function ChampDossier({ id, libelle, tree, valeur, onChange }) {
  return (
    <div className="v2-champ">
      <label className="v2-label" htmlFor={id}>{libelle}</label>
      <select id={id} value={valeur} onChange={(e) => onChange(e.target.value)}>
        {optionsDossiers(tree).map((d) => (
          <option key={d.value} value={d.value}>{d.label}</option>
        ))}
      </select>
    </div>
  );
}

// --- Televerser un fichier ---

export function ModaleTeleversement({ tree, onValider, onClose }) {
  const [dossier, setDossier] = useState("");
  const [fichier, setFichier] = useState(null);
  const [enCours, setEnCours] = useState(false);
  const [erreur, setErreur] = useState(null);

  const valider = async () => {
    if (!fichier) { setErreur("Choisissez un fichier."); return; }
    setEnCours(true);
    setErreur(null);
    try {
      await onValider(dossier, fichier);
    } catch (e) {
      setErreur(e.message || "Erreur upload.");
      setEnCours(false);
    }
  };

  return (
    <ModaleV2
      titre="Uploader un fichier"
      onClose={onClose}
      bloquee={enCours}
      actions={
        <>
          <button type="button" className="v2-btn v2-btn-secondaire" onClick={onClose} disabled={enCours}>Annuler</button>
          <button type="button" className="v2-btn v2-btn-principal" onClick={valider} disabled={enCours || !fichier}>
            {enCours ? "Upload…" : "Uploader"}
          </button>
        </>
      }
    >
      <ChampDossier id="v2-upload-dossier" libelle="Dossier cible" tree={tree} valeur={dossier} onChange={setDossier} />
      <div className="v2-champ">
        <label className="v2-label" htmlFor="v2-upload-fichier">Fichier</label>
        <input id="v2-upload-fichier" type="file" className="v2-champ-fichier" onChange={(e) => setFichier(e.target.files[0] || null)} />
        {fichier && <span className="v2-champ-aide">{fichier.name} — {(fichier.size / 1024).toFixed(0)} Ko</span>}
      </div>
      {erreur && <div className="v2-msg v2-msg-erreur">{erreur}</div>}
    </ModaleV2>
  );
}

// --- Nouveau dossier ---

export function ModaleNouveauDossier({ tree, onValider, onClose }) {
  const [parent, setParent] = useState("");
  const [nom, setNom] = useState("");
  const [enCours, setEnCours] = useState(false);
  const [erreur, setErreur] = useState(null);

  const valider = async () => {
    if (!nom.trim()) { setErreur("Donnez un nom de dossier."); return; }
    setEnCours(true);
    setErreur(null);
    try {
      await onValider(parent ? `${parent}/${nom.trim()}` : nom.trim());
    } catch (e) {
      setErreur(e.message || "Erreur creation du dossier.");
      setEnCours(false);
    }
  };

  return (
    <ModaleV2
      titre="Nouveau dossier"
      onClose={onClose}
      bloquee={enCours}
      actions={
        <>
          <button type="button" className="v2-btn v2-btn-secondaire" onClick={onClose} disabled={enCours}>Annuler</button>
          <button type="button" className="v2-btn v2-btn-principal" onClick={valider} disabled={enCours || !nom.trim()}>
            {enCours ? "Création…" : "Créer le dossier"}
          </button>
        </>
      }
    >
      <ChampDossier id="v2-dossier-parent" libelle="Dossier parent" tree={tree} valeur={parent} onChange={setParent} />
      <div className="v2-champ">
        <label className="v2-label" htmlFor="v2-dossier-nom">Nom du dossier</label>
        <input
          id="v2-dossier-nom"
          type="text"
          value={nom}
          onChange={(e) => setNom(e.target.value)}
          onKeyDown={(e) => { if (e.key === "Enter") valider(); }}
          placeholder="Ex : 06_Nouveau_Dossier"
          autoFocus
        />
      </div>
      {erreur && <div className="v2-msg v2-msg-erreur">{erreur}</div>}
    </ModaleV2>
  );
}

// --- Choix du dossier avant creation d'une procedure ---

export function ModaleChoixDossier({ tree, onValider, onClose }) {
  const [dossier, setDossier] = useState("");
  return (
    <ModaleV2
      titre="Nouvelle procédure"
      onClose={onClose}
      actions={
        <>
          <button type="button" className="v2-btn v2-btn-secondaire" onClick={onClose}>Annuler</button>
          <button type="button" className="v2-btn v2-btn-principal" onClick={() => onValider(dossier)}>Continuer</button>
        </>
      }
    >
      <ChampDossier id="v2-choix-dossier" libelle="Dossier cible" tree={tree} valeur={dossier} onChange={setDossier} />
    </ModaleV2>
  );
}
